import Swal from "sweetalert2";
import { opcoesToast, opcoesToastErro } from "@/common/erros/toast.options";
const confirmarMixin = Swal.mixin({
  customClass: {
    container: "swal-customizado",
    confirmButton: "btn btn-valorem-ciano",
    cancelButton: "btn btn-outline-valorem-ciano",
    denyButton: "btn btn-outline-valorem-ciano mr-2",
    closeButton: "btn",
  },
  buttonsStyling: false,
});
// Exportado para o src/common/erros/apresentacao.js abrir o modal de erro
// sistêmico com o mesmo visual, inclusive fora de componente (ApiService).
export const alertasMixin = Swal.mixin({
  customClass: {
    container: "swal-customizado swal-alertas",
    confirmButton: "btn btn-valorem-ciano",
    cancelButton: "btn btn-outline-valorem-ciano",
    denyButton: "btn btn-outline-valorem-ciano mr-2",
    closeButton: "btn",
    icon: "icon-class",
  },
  buttonsStyling: false,
});
export const AlertasMixin = {
  methods: {
    confirmar: function (
      titulo,
      mensagem,
      botaoConfirmar = "Sim",
      botaoCancelar = "Não"
    ) {
      return new Promise((resolve) => {
        confirmarMixin
          .fire({
            title: titulo,
            text: mensagem,
            showDenyButton: true,
            showCloseButton: true,
            reverseButtons: true,
            confirmButtonText: botaoConfirmar,
            denyButtonText: botaoCancelar,
          })
          .then((result) => {
            resolve(result.isConfirmed);
          });
      });
    },
    alertaSucesso: function (mensagem, permitirFechar = true) {
      return new Promise((resolve) => {
        alertasMixin
          .fire({
            text: mensagem,
            icon: "success",
            showConfirmButton: permitirFechar,
            allowOutsideClick: permitirFechar,
            allowEscapeKey: permitirFechar,
          })
          .then(() => {
            resolve();
          });
      });
    },
    // html é opcional: o modal de erro sistêmico usa para mostrar o código de
    // suporte em destaque, abaixo da mensagem. Quando vem, substitui o text.
    alertaErro: function (mensagem, html = null) {
      alertasMixin.fire({
        text: html ? undefined : mensagem,
        html: html || undefined,
        icon: "error",
        confirmButtonText: "Ok",
      });
    },
    alertaAviso: function (mensagem) {
      alertasMixin.fire({
        text: mensagem,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    },
    toast: function (mensagem, options) {
      this.$bvToast.toast(mensagem, {
        title: options.title ? options.title : "",
        toaster: options.position ? options.position : "b-toaster-bottom-right",
        solid: true,
        appendToast: true,
        variant: options.variant ? options.variant : "info",
      });
    },

    toastSucesso: function (mensagem) {
      this.$toast.success(
        mensagem,
        opcoesToast({ toastClassName: "toast-sucesso" })
      );
    },

    // Erro fica 8s na tela (antes 3s): o usuário precisa ler o que corrigir.
    toastErro: function (mensagem) {
      this.$toast.error(mensagem, opcoesToastErro());
    },

    toastAlerta: function (mensagem) {
      this.$toast.warning(
        mensagem,
        opcoesToastErro({ toastClassName: "toast-alerta" })
      );
    },
  },
};
